<template>
  <div class="progress-wrap under-gray-line">
    <div class="title">
      <slot name="text"></slot>
    </div>
    <div class="step">
      <slot name="step1">
        <div class="progress-off"></div>
      </slot>
      <slot name="step2">
        <div class="progress-off"></div>
      </slot>
      <slot name="step3">
        <div class="progress-off"></div>
      </slot>
      <slot name="step4">
        <div class="progress-off"></div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
